import React, { useState, useEffect } from 'react';
import './SignInModal.css';

// Added onSwitchToRegister and onSwitchToForgotPassword props
const SignInModal = ({ isActuallyOpen, onClose, onSwitchToRegister, onSwitchToForgotPassword }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isActuallyOpen) {
      const timer = setTimeout(() => setIsVisible(true), 20);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isActuallyOpen]);

  const handleOverlayClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  const handleCloseButtonClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Attempting sign in with:', { username, password });
  };

  // Generic switch function for modals
  const switchModals = (e, switchFunction) => {
    e.preventDefault();
    setIsVisible(false); // Start fade out of current modal
    setTimeout(() => {
      onClose(); // Tell App.js to close current modal
      if (switchFunction) {
        switchFunction(); // Tell App.js to open the new one
      }
    }, 300); // Wait for fade-out transition
  };
  
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isActuallyOpen) {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isActuallyOpen, onClose]);

  if (!isActuallyOpen) {
    return null;
  }

  return (
    <div
      className={`modal-overlay ${isVisible ? 'open' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-content" onClick={handleModalContentClick}>
        <div className="modal-header">
          <h2>Sign In</h2>
          <button onClick={handleCloseButtonClick} className="modal-close-button" aria-label="Close modal">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div className="form-actions">
            <button type="submit">Sign In</button>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px'}}>
              <a href="#register" onClick={(e) => switchModals(e, onSwitchToRegister)} className="form-link">Register</a>
              <a href="#forgot-password" onClick={(e) => switchModals(e, onSwitchToForgotPassword)} className="form-link">Forgot password?</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignInModal;